import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois';
import { API_ROUTES } from '../../../utility/api.routes';
import { toast } from 'react-toastify';

export const getAllInquirySources = createAsyncThunk(
    "inquirySource/getInquirySource",
    async () => {
        try {
            const url = API_ROUTES.INQUIRY_SOURCE.GET_INQUIRY_SOURCE
            const response = await apiClient.get(url)
            return response?.data?.result

        } catch (error) {
            console.error("builder function error:", error);
            throw error;
        }
    }
);

export const createInquirySource = createAsyncThunk(
    "inquirySource/createInquirySource",
    async (data, {dispatch}) => {
        try {

            const inquirySourceData = {
              inquirySourceName: data.value.inquirySourceName,
              inquirySourceStatus: 'active',
            }

            const url = API_ROUTES.INQUIRY_SOURCE.GET_INQUIRY_SOURCE
            const response = await apiClient.post(url, inquirySourceData)

            dispatch(getAllInquirySources())

            if (response?.status) {
                data.setOpen(false)
                toast.success(response.data.message, {
                    className: 'custom-toast-success',
                    progressStyle: { background: '#ffffff' },
                })
            }


        } catch (error) {
            console.error("builder function error:", error);
            toast.error(error.response.data.message, {
                className: 'custom-toast-error',
                progressStyle: { background: '#C53C43' },
            })
            throw error;
        }
    }
);


export const editInquirySource = createAsyncThunk(
    "inquirySource/editInquirySource",
    async (data, {dispatch}) => {
        try {


            const inquirySourceData = {
              inquirySourceName: data.value.inquirySourceName,
              inquirySourceStatus: data.value.inquirySourceStatus,
            }

            const url = API_ROUTES.INQUIRY_SOURCE.PUT_INQUIRY_SOURCE(data.value.inquirySourceId)
            const response = await apiClient.put(url, inquirySourceData)

            
            if (response?.status) {
                data.setEditInventoryDrawer(false)
                dispatch(getAllInquirySources())
                toast.success(response.data.message, {
                    className: 'custom-toast-success',
                    progressStyle: { background: '#ffffff' },
                })
            }


        } catch (error) {
            console.error("builder function error:", error);
            toast.error(error.response.data.message, {
                className: 'custom-toast-error',
                progressStyle: { background: '#C53C43' },
            })
            throw error;
        }
    }
);